import Index from "../views/index.vue";
import About from "../views/about.vue";
import Curriculum from "../views/curriculum.vue";
import Eblocks from "../views/eblocks.vue";
import Franchise from "../views/franchise.vue";

export default [
    {
        path: '/index',
        component: Index,
    },
    {
        path: '/about',
        component: About,
    },
    {
        path: '/franchise',
        component: Franchise,
    },
    {
        path: '/eblocks',
        component: Eblocks,
    },
    {
        path: '/curriculum',
        component: Curriculum,
    },
    {
        path: '*',
        redirect:'/index',
    },
];



// WEBPACK FOOTER //
// ./src/router/router.js